<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("cuentasAparcadas") }}</template>
      </breadcrumb>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :quitarFechas="false"
        :dateto="dateto" 
        :datefrom="datefrom"                                                      
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="dateInform.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-6  text-left">
              <el-select
                    class="select-default"
                    size="large"
                    v-model="nameCliente"
                    filterable
                    remote
                    :placeholder="'Filtrar por nombre'"
                    @change="filtrarPorNombre"
                  >
                    <el-option
                      class="select-primary"
                      :value="''"
                      :label="'Todos'"
                      :key="-1"
                    >
                    </el-option>
                    <el-option
                      v-for="(p, i) in listClientes"
                      class="select-primary"
                      :value="p"
                      :label="p"
                      :key="i + '_cliente'"
                    >
                    </el-option>
                  </el-select>
            </div>
            <div class="col-md-6  text-right">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("fecha") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarNumOperaciones"
                      @click="sortedArrayASC(2), (ordenarNumOperaciones = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("operacion") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(2), (ordenarNumOperaciones = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("operacion") }}
                    </span>
                  </th>

                  <th>
                    <span
                      v-if="ordenarNombre"
                      @click="sortedArrayASC(3), (ordenarNombre = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("nombre") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(3), (ordenarNombre = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("nombre") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarImporte"
                      @click="sortedArrayASC(4), (ordenarImporte = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("importe") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(4), (ordenarImporte = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("importe") }}
                    </span>
                  </th>
                  <th>{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(obj, index) in dateInform" :key="obj.id || index">
                  <td>
                    <span :class="getClassDay(obj.date)"
                      >{{ obj.date | getDia }} {{ obj.date | parseDate }}
                      {{ obj.date | parseMinSec }}</span
                    >
                  </td>
                  <td>{{ obj.workerName }}</td>
                  <td>{{ obj.name }}</td>
                  <td align="right">{{ obj.amount | currency }}</td>
                  <td align="center">
                    <i
                      @click="openModal(obj.id)"
                      v-tooltip.top-center="$t('desglose')"
                      class="fa fa-info-circle"
                    ></i>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td><strong>Total:</strong></td>
                  <td></td>
                  <td></td>
                  <td align="right">
                    <strong>{{ total | currency }}</strong>
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayCuentasAparcadasEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>
    </div>

    <modal
      name="desgloseModal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("desglose") }}</h4>
        </div>
        <div class="modal-body">
          <div
            v-if="dateInform.length > 0"
            class="table-responsive"
            style="overflow: auto"
          >
            <table class="table table-bordered table-striped ">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t("producto") }}</th>
                  <th>{{ $t("importe") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in dateInformDet">
                  <td>{{ obj.units }} x {{ obj.name }}</td>
                  <td align="right">{{ obj.amount | currency }}</td>
                </tr>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td align="right">
                    <strong>{{ totalDet | currency }}</strong>
                  </td>
                </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i> {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  Loading,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Datetime from "vue-datetime";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import { mapState } from 'vuex'

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("cuentasAparcadas"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Datetime]: Datetime,
    Breadcrumb,
    CabeceraInformes,
  },
  
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      data: [""],
      idTpv: -1,
      listTpv: [],
      cuentasAparcadas: false,
      dateInform: ["-"],
      dateInformDet: ["-"],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      indice: 0,

      //ORDENAR
      ordenarFecha: 0,
      ordenarNumOperaciones: 0,
      ordenarNombre: 0,
      ordenarImporte: 0,

      respuesta: true,

      listCompany: [],
      listClientes: [],
      nameCliente: ""
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportCuentasAparcadas/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportCuentasAparcadas/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    total() {
      let total = 0;

      this.dateInform.forEach(function(x) {
        total += x.amount;
      });

      return total;
    },

    totalDet() {
      let total = 0;

      this.dateInformDet.forEach(function(x) {
        total += x.amount;
      });

      return total;
    },
  },
  methods: {
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    filtrarPorNombre(query) {

      this.dateInform = [];

      if (query != "") {
        this.dateInformQuery.forEach((cuenta) => {
          if (cuenta.name == query) {
            this.dateInform.push(cuenta);
          }
        });
      } else {
        this.dateInform = this.dateInformQuery;
      }
      
    },
    sortedArrayASC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 1;

          function compareDate(a, b) {
            if (a.date.toUpperCase() < b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() > b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 2:
          this.ordenarNumOperaciones = 1;

          function compareOperacion(a, b) {
            if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
              return -1;
            if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareOperacion);

        case 3:
          this.ordenarNombre = 1;

          function compareNombre(a, b) {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareNombre);

        case 4:
          this.ordenarImporte = 1;

          function compareImporte(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareImporte);
      }
    },
    sortedArrayDESC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 0;

          function compareFecha(a, b) {
            if (a.date.toUpperCase() > b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() < b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareFecha);

        case 2:
          this.ordenarNumOperaciones = 0;

          function compareOperacion(a, b) {
            if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
              return -1;
            if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareOperacion);

        case 3:
          this.ordenarNombre = 0;

          function compareName(a, b) {
            if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.data.sort(compareName);

        case 4:
          this.ordenarImporte = 0;

          function compareImporte(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.data.sort(compareImporte);
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.cambioTpv(-1, false);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    openModal(id) {
      this.indice = id;

      this.getCuentasAparcadasDet(id);

      this.$modal.show("desgloseModal");
    },

    cerrarModal() {
      this.$modal.hide("desgloseModal");
    },

    cambioBusiness(idBusinessData, listTpv) {

      this.nameCliente = "";
      this.listClientes = [];

      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.cambioTpv()
    },
    emitirConsulta() {
      this.getCuentasAparcadas();
    },
    cambioTpv(idTpvData, filtrar) {

      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }
      
      this.emitirConsulta();
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
              vm.getCuentasAparcadas();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },

    getCuentasAparcadas() {
      this.loading = Loading.service({ text: "Cargando..." });

      let secondsDesde = moment(this.datefrom)
        .startOf("day")
        .unix();
      let secondsHasta = moment(this.dateto)
        .endOf("day")
        .unix();
        
      var config = {
        params: {
          idTpv: this.idTpv,
          idBusiness: this.idBusiness,
          datefrom: secondsDesde,
          dateto: secondsHasta,
          jwt: this.$store.getters.jwt
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "sales/getCuentasAparcadas", config)
        .then(function(response) {
          if (response.data.response) {
            // console.log(response.data.result);
            vm.dateInform = response.data.result;
            vm.dateInformQuery = response.data.result;

            vm.listClientes = [];

            vm.dateInform.forEach((cuenta) => {
              vm.listClientes.push(cuenta.name);
            })
            vm.respuesta = true;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getCuentasAparcadasDet(idHeader) {
      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idHeader: idHeader,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "sales/getCuentasAparcadasDet",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.dateInformDet = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getClassDay(date) {
      var classDay = "";
      var humanDate = moment.unix(date);
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/CuentasAparcadas.vue